export const getExpirationDate = (typedDate: string) => ({
  expirationMonth: typedDate.substring(0, 2),
  cardTypeYear: typedDate.substring(typedDate.length - 2, typedDate.length),
  expirationYear: `20${typedDate.substring(typedDate.length - 2, typedDate.length)}`,
});

export default getExpirationDate;
